import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './FormLabel.module.scss'
import { FormLabelProps } from './types'

const FormLabel: React.FC<FormLabelProps> = forwardRef(
  (
    {
      Tag = 'label',
      className,
      children,
      isMarginless,
      isRequired,
      hasEllipsis,
      hasDataTrackingPii,
      testId,
      ...props
    },
    ref,
  ) => {
    const formLabelClassNames = cn(
      styles.label,
      className,
      isMarginless && styles.marginless,
      isRequired && styles.required,
      hasEllipsis && styles.ellipsis,
    )

    return (
      <Tag
        className={formLabelClassNames}
        data-tracking-pii={hasDataTrackingPii}
        data-testid={testId}
        ref={ref}
        {...props}
      >
        {children}
      </Tag>
    )
  },
)

export default FormLabel
